<template>
	<div class="bg_main">
		<!-- <div class="fullwidth height300r overhide"
			:style="'background-image: url('+(detail.imgArr?detail.imgArr[0]:'')+');background-position:center center;background-size:100% auto;'">
			<img class="hidden  autoheight" mode="widthFix" :src="detail.imgArr?detail.imgArr[0]:''" />
		</div> -->


		<div class="paddingt10 paddingr15 paddingl15 ">
			<div class="bg_white padding10 ">
				<div  class="size1 ">{{detail.name}}</div>
				<div class="size3 lineh1 color_red">
					￥{{ detail.minPrice==detail.maxPrice?detail.minPrice:(detail.minPrice+" - "+detail.maxPrice) }}
				</div>

			</div>
		</div>

		<div class="paddingt10 paddingr15 paddingl15">
			<div class="bg_white padding10 ">

				<!-- <div class="hidden flex_row_t padding0">
					<div class="color3 size4 width50 minwidth50">选择</div>
					<div @click="toSelectSpec(3)" class="fullwidth paddingl10">
						<block v-if="detail.specItemList" v-for="(item,index) in detail.specItemList">
							<div class="marginr10 size4 inline">{{item.showName}}</div>
						</block>
					</div>
					<span class="uni-icon opacity5"> &#xe470; </span>
				</div>

				<div v-if="detail.specItemList && detail.specItemList.length>0" class=" flex_row_t padding0">
					<div class="color3 size4 width50 minwidth50"></div>
					<div @click="toSelectSpec(3)" class="fullwidth paddingl10">
						<block v-for="(item2,index2) in detail.specItemList[0].valueList">
							<div v-if="item2.isSelected===1"
								class="radius5 marginr10 inline paddingl10 paddingr10 paddingt5 paddingb5 border_red color_red">
								{{ item2.name }}</div>
						</block>
					</div>
				</div> -->

				<div class=" flex_row_t padding0">
					<div class="color3 size4 width50 minwidth50">配送自</div>
					<div class="fullwidth paddingl10  ">
						<div class="inline marginr10">{{selectedShop.address}}</div>
						<div class="hidden inline marginr10">快递</div>
					</div>
				</div>

				<div class="hidden flex_row_t padding0">
					<div class="color3 size4 width50 minwidth50">保障</div>
					<div class="fullwidth paddingl10  ">
						<div v-if="selectedShop.type!='xs_node'" class="inline marginr10">7天无条件退货</div>
						<div class="inline marginr10">假一罚三</div>
					</div>
				</div>

				<div class="hidden flex_row_t padding0">
					<div class="color3 size4 width50 minwidth50">活动</div>
					<div class="fullwidth paddingl10  ">
						<div class="inline marginr10">满300送</div>
						<div class="inline marginr10">免快递费</div>
					</div>
				</div>

				<div class="flex_row_t padding0 hidden">
					<div class="color3 size4 width50 minwidth50">参数</div>
					<div class="fullwidth paddingl10  ">
						<div class="inline marginr10">品牌</div>
						<div class="inline marginr10">原料</div>
					</div>
				</div>

			</div>
		</div>

		<div class="center padding10 color3">商品详情</div>
		<div class="article-content">
			<!-- <rich-text :nodes="detail.content"></rich-text> -->
			<div v-html="detail.content"></div>
		</div>
		


		<div class="fixed fixed_l_r bottom0 bg_main flex_row content_width">
			<div @click="callPhone()" class="center">
				<img class="width18 height18 block  automargin" src="@/assets/images/order_wait_pingjia.png" />
				<div class="size5 color3">客服</div>
			</div>
			<div @click="toCart()" class="center">
				<img class="width18 height18 block automargin" src="@/assets/images/b8_on.png" />
				<div class="size5 color3">购物车</div>
			</div>
			<div class="flex_row_s autowidth padding0 " style="width:70%">
				<div @click="toSelectSpec('cart')"
					class="flex1 nowrap center radiusl20 padding7 paddingl20 bg_orange color5">
					加入购物车</div>
				<div @click="toSelectSpec('buy')"
					class="flex1 nowrap center radiusr20 padding7 paddingr20 bg_red color5">
					立即购买</div>
			</div>
		</div>
		
		<div class="spaceh50"></div>


		<!-- 普通弹窗 -->
		<uni-popup ref="select_popup" background-color="#fff" @change="popChange">
			<scroll-view @touchmove.stop scroll-y="true" 
				class="fullheight overscroll popup-content padding10 left  h5maxwidth automargin"
				:class="{ 'popup-height': popType === 'left' || popType === 'right' }">

				<div class="flex_row_s">
					<img :src="detail.imgArr?detail.imgArr[0]:''" @click="previewImage(detail.imgArr?detail.imgArr[0]:'')" class="width160r height160r border" />
					<div class="padding10">
						<div class="size3 paddingb10">{{detail.name}}</div>
					</div>
				</div>

				<div class="spec_box">
					<div class=" padding10 fullwidth  overscroll">
						<div v-for="(item,index) in detail.goodsSpecList" v-bind:key="index" class="fullwidth">

							<div class="bg_eee   padding0 marginb20">
								<div class="  flex_row_h padding0">

									<!-- 显示规格名 -->
									<div v-for="(item2,index2) in item.nameDisplay" v-bind:key="'b_'+index2" 
										class="flex_row padding10    radius8 ">
										
										<img v-if="item2.img" :src="item2.img" @click="previewImage(item2.img)"
											:class="'middle flex_shrink0 autowidth height50 marginr10 radiusl10 inline '+ (item.isSelected?' border_red':'border') "
											mode="heightFix" />
											
										<div v-if="!!item2.name==true" @click="previewImage(item2.img)" 
											:class="'middle inline color1 size4  '+(!!item2.img==false?'radius10':'radiusr10') ">
											{{item2.name}}
										</div>
									</div>
								</div>

								<div class="flex_row padding0 bg_white">

									<div class="fullwidth">
										<!-- 价格 -->
										<div class="inline size3 padding5  color_red">
											￥{{item.price==0?'待下单确认':item.price}}</div>
										<div class="inline color2 padding5 ">（余{{item.store-item.orderedCount}}）
										</div>
									</div>

									<div class="inline padding0 marginr5">
										<!-- 数量加减 -->
										<div class="flex_row_s padding0 autowidth">
											<div class="height50 nowrap flex_row_s padding0 autowidth">
												<div v-if="item.currOrderCount>0"
													@click.stop.prevent="changeCount( '-',item)"
													class="uni-icon uni-icon-minus-filled   middle inline color_orange  bold sizeb">
												</div>
												<div v-if="item.currOrderCount>0"
													class="radius5 middle inline  border color_red width40 height40 margin5 lineh40 center">
													{{item.currOrderCount?item.currOrderCount:0}}
												</div>
												<div @click.stop.prevent="changeCount( '+',item)"
													class="uni-icon uni-icon-plus-filled  middle inline color_green  bold sizeb ">
												</div>
											</div>

										</div>
									</div>
								</div>

							</div>

						</div>
					</div>
				</div>

				<div v-if="currOperate=='buy'" @click="toBuy()" class="padding10 radius40 marginl10 marginr10 center bg_red color5">立即购买
				</div>

		
			</scroll-view>
		</uni-popup>


	</div>
</template>

<script>

import uniPopup from '@/components/uni-popup/uni-popup.vue';

export default {
		components: {
			uniPopup
		},
		data() {
			return {
				id: 0,
				title: '',
				detail: {},
				htmlNodes: [],
				currOperate: "", //当前操作：cart购物车，buy购买，3购物车&购买
				popType: '',
				orderedSpecItem: {}, //订购的规格项目{id:value}
				orderedSpec: {}, //订购的商品规格
				selectedGoodsSpecIndex: -1, // 选择de规格 
				//currOrderCount: 0, //订购数量
				currPrice: 0, //订购价格
				selectedShop: {},
				showPopup:false,
			}
		},
		created() {


			// TODO 后面把参数名替换成 payload
			// const payload =  this.$route.query.detailDate ||  this.$route.query.payload;
			var options=this.$route.query || {};
			this.id =  options.id;
			if (!!this.id == false) {
				alert( "需要ID" );
				return;
			}

			this.selectedShop = window.$utils.uniapi.getStorageSync("selectedShop") || {};


			//查询
			this.getDetail();
		},
		onShareAppMessage() {
			return {
				title: this.detail.name,
				path: window.$config.pageHost
			}
		},
		onNavigationBarButtonTap(event) {
			const buttonIndex = event.index;
			if (buttonIndex === 0) {
				// 分享 H5 的页面
				const shareProviders = [];
				// uni.getProvider({
				// 	service: 'share',
				// 	success: (result) => {
				// 		// 目前仅考虑分享到微信
				// 		if (result.provider && result.provider.length && ~result.provider.indexOf('weixin')) {
				// 			const channels = _handleShareChannels(result.provider);
				// 			uni.showActionSheet({
				// 				itemList: channels.map(channel => {
				// 					return channel.text;
				// 				}),
				// 				success: (result) => {
				// 					const tapIndex = result.tapIndex;
				// 					uni.share({
				// 						provider: 'weixin',
				// 						type: 0,
				// 						title: this.detail.name,
				// 						scene: tapIndex === 0 ? 'WXSceneSession' :
				// 							'WXSenceTimeline',
				// 						href: window.$config.pageHost,
				// 						imageUrl: 'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dc-site/b6304f00-5168-11eb-bd01-97bc1429a9ff.png'
				// 					});
				// 				}
				// 			});
				// 		} else {
				// 			uni.showToast({
				// 				title: '未检测到可用的微信分享服务'
				// 			});
				// 		}
				// 	},
				// 	fail: (error) => {
				// 		uni.showToast({
				// 			title: '获取分享服务失败'
				// 		});
				// 	}
				// });
			}
		},
		methods: {
			previewImage(img){
				window.$utils.uniapi.previewImage(img);
			},
			parseItemValue() {
				var specItemList = this.detail.specItemList;
				//value解析
				for (var i = 0; i < specItemList.length; i++) {
					var valueArr = specItemList[i].value.split(",");
					specItemList[i]['valueList'] = [];
					for (var k = 0; k < valueArr.length; k++) {
						var ss = this.isUsedItemValue(specItemList[i].id, valueArr[k]);
						specItemList[i].valueList.push({
							name: valueArr[k],
							isUsed: (ss == 2 ? true : false),
							isSelectable: (ss == 1 ? true : false)
						});
					}
				}
				console.log(specItemList);
				this.detail.specItemList = specItemList;
				this.$forceUpdate();
			},
			/**
			 * 1.使用中的（规格项目值是否存在于商品规格中）
			 * 2.可选择的 （且存在于选中的规格中）
			 * @param {Object} id
			 * @param {Object} itemValue
			 */
			isUsedItemValue(id, itemValue) {

				var specList = this.detail.goodsSpecList;
				var specItemList = JSON.parse(this.detail.specItemJson);
				//规格项目id序号
				var sn = this.getSpecItemSn(id);
				console.log("sn==" + sn);
				if (sn >= 0) {
					var specName = "";
					for (var i = 0; i < specList.length; i++) {
						//排除未含选中项的规格
						var isInseled = this.isInSelectedSpecItem(specList[i].name);
						var nameArr = specList[i].name.split(",");
						if (nameArr[sn] == itemValue) {
							if (isInseled) {
								return 2; //可选的
							} else {
								return 1; //有用的
							}
						}
					}
				}
				return 0;
			},
			//规格是否在选中的项目中
			isInSelectedSpecItem(specName) {

				var selectedMap = this.orderedSpecItem;
				if (!!selectedMap == false || Object.keys(selectedMap).length == 0) {
					return true;
				}
				for (var k in selectedMap) {
					var sn = this.getSpecItemSn(k);
					if (specName.split(",")[sn] == selectedMap[k]) {
						return true;
					}
				}
				return false;
			},
			//获取规格项目ID的顺序号
			getSpecItemSn(specItemId) {
				var specItemList = JSON.parse(this.detail.specItemJson);
				//项目id排序
				var ids = [];
				for (var i = 0; i < specItemList.length; i++) {
					ids.push(specItemList[i].id);
				}
				//查询id在规格项目中的排序sn
				var sn = -1;
				ids.sort();
				for (var i = 0; i < ids.length; i++) {
					if (specItemId == ids[i]) {
						sn = i;
						break;
					}
				}
				return sn;
			},
			toSelectSpec(currOperate) {
				console.log(currOperate);
				try{
					this.currOperate = currOperate;
					this.$refs.select_popup.open("right");
					//this.showPopup=true;
				}catch(err){
					console.log(err);
				}
				
			},

			popChange(e) {
				console.log(e);
			},
			//点选规格项目
			clickSpecItemValue(id, value) {
				this.orderedSpecItem[id] = value; //保持记录
				this.parseItemValue();

				this.changePrice();
				this.$forceUpdate();
			},
			//依选择的规格显示对应价格
			changePrice() {
				this.orderedSpec = {};

				var arr = [];
				for (let k in this.orderedSpecItem) {
					arr.push(k);
				}
				if (arr.length != this.detail.specItemList.length) {
					console.log("还未选齐全");
					return;
				}

				arr.sort(this.compare);
				console.log(arr);
				var specName = ""; //规格名
				for (var i = 0; i < arr.length; i++) {
					specName += this.orderedSpecItem[arr[i]] + (i == arr.length - 1 ? '' : ",");
				}
				for (var i = 0; i < this.detail.goodsSpecList.length; i++) {
					console.log(this.detail.goodsSpecList[i].name + "---" + specName);
					if (this.detail.goodsSpecList[i].name == specName) {
						this.orderedSpec = this.detail.goodsSpecList[i];
						//this.$forceUpdate();
						this.selectedGoodsSpecIndex = i;
						return;
					}
				}
				alert( "暂无此规格" );
			},

			/**
			 * 比较函数
			 * 用法：
			 * var arr = [23, 9, 4, 78, 3];
			 * console.log(arr.sort(this.compare));
			 */
			compare(x, y) {
				if (x < y) {
					return -1;
				} else if (x > y) {
					return 1;
				} else {
					return 0;
				}
			},



			getDetail() {
				var that=this;
				this.$axios.request({
						url: window.$config.url.getGoodsDetail,
						data: { id: this.id }
					})
					.then(res => {
						window.$utils.uniapi.stopPullDownRefresh();
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							try{
								that.detail = res.data;
								
								that.makeSpecNameDisplay();
								that.fromCart();
							}catch(err){console.log("err----",err);}

						} else if (!!res.msg == true) {
							alert( res.msg );
						} else {
							alert( "不成功" );
						}
					})
					.catch(err=>{
						console.log("err",err );
					});
			},
			//goodsObj成功后，添加规格显示字段
			makeSpecNameDisplay(){
			    try{
					var that=this;
					var goodsObj=that.detail;
					for(var i=0;i<goodsObj.goodsSpecList.length;i++){
						goodsObj.goodsSpecList[i].nameDisplay=that.getSpecItemNameDisplay(goodsObj.goodsSpecList[i].name);
					}
					that.detail=goodsObj;
					console.log("添加规格显示字段",goodsObj);
				}catch(err){
					console.log(err);
				}
			},
			
			
			  /**
			   * 依规格名，生成显示数据
			   * 图文的项目，显示图片+文字
			   * 返回对象数组[{}]
			   */
			  getSpecItemNameDisplay(name){
			    console.log(name);
			    if(!!name==false)return;
			    var nameArr=name.split(",");
			    var goodsSpecItemList=this.detail.goodsSpecItemList;
			    if(nameArr.length!=goodsSpecItemList.length){
			        alert('规格错误' ); return ;
			    }
			    goodsSpecItemList.sort(function(a,b){return a.id-b.id;});
			    //console.log("排序后",goodsSpecItemList);
			    
			    var list=[];
			    for(var i=0;i<nameArr.length;i++){
			        var valArr=goodsSpecItemList[i].value.split(",");//项目数据
			        if(!window.$utils.inArray(valArr,nameArr[i])){
			            alert('规格数据错误' ); return ;
			        }
			        if(goodsSpecItemList[i].type=='img'){
			            var imgArr=goodsSpecItemList[i].img.split(",");
			            for(var p=0;p<valArr.length;p++){
			                //依位置确定img
			                if(valArr[p]==nameArr[i]){
			                    list.push({name:nameArr[i],img:imgArr[p]});
			                    break;
			                }
			            }
			        }else{
			            list.push({name:nameArr[i]});
			        }
			    }
			    return  list;
			  },
			  
			  
			addCart() {

			},
			
			toBuy(){
				console.log("toBuy");
				if(this.detail.currOrderCount>0){
					this.toCart()
				}else{
					alert("请选数量"  )
				}
			},
			

			/**
			 * 从购物车采集订购数据
			 * 商品数据获取完成后，初始购物车
			 */
			fromCart() {
				
				var that = this;
				this.cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];
				
				//在购物车中的按购物车数据
				for (var c = 0; c < this.cartGoodsList.length; c++) {
					if (this.detail.id == this.cartGoodsList[c].id) {
						//商品当前订购数量
						this.detail.currOrderCount = this.cartGoodsList[c].currOrderCount;
						//进一步赋值规格订购数量
						for(var cs = 0; cs < this.cartGoodsList[c].goodsSpecList.length; cs++){
							for (var gs = 0; gs <this.detail.goodsSpecList.length; gs++) {
								if(this.detail.goodsSpecList[gs].id==this.cartGoodsList[c].goodsSpecList[cs].id){
									this.detail.goodsSpecList[gs].currOrderCount=this.cartGoodsList[c].goodsSpecList[cs].currOrderCount;
								}
							}
						}
						break;
					}
				}
			},
			
			toCart() {
				this.$router.push({ path: "/tabbar_cart_index" });
			},



			/**
			 * 数量增减
			 */
			changeCount( action, specObj) {
				try{
					var goodsId = specObj.goodsId;
					var goods=this.detail;
					var specId=specObj.id;

					// if (goods.goodsSpecList.length == 1) {
					// 	specId = goods.goodsSpecList[0].id;
					// }
					console.log("changeCount", action, specObj);

					if (!!specId == false) {
						this.selectedGoods = goods;
						this.$refs.select_popup.open("right");
						return;
					}

						
					var goodsObj = null;
					if (this.detail) {
						console.log("适用单一商品");
						goodsObj = this.changeCountForObj(action, specId);
					} else {
						console.log("适用商品List");
						goodsObj = this.changeCountForList(action, goodsId, specId);
					}


					if(typeof goodsObj=='string'){
						alert(goodsObj );return;
					}
					
					//加入购物车
					this.$nextTick(() => { this.addCart(goodsObj); }); //.updateCartGoodsList();


					//更新购物车
					//that.updateCart(goodsId);
					//that.updateCartGoodsList();
				}catch(err){
					console.log(err);
				}

			},

			/**
			 * 更新单个商品数量（选定的包装数量）
			 */
			changeCountForObj(action, specId) {
				try{
					
					var goodsCount = 0; //单品订购数量
					//var goodsObj = JSON.parse(JSON.stringify( this.detail));
					//console.log("goodsObj...1",goodsObj);
					for (var p = 0; p < this.detail.goodsSpecList.length; p++) {
						if (this.detail.goodsSpecList[p].id == specId) {

							if(typeof this.detail.goodsSpecList[p].currOrderCount=="undefined")this.detail.goodsSpecList[p].currOrderCount=0;
							
							// 检查库存
							if(action == "+" && this.detail.storeShare==0 
								&& this.detail.goodsSpecList[p].store < this.detail.goodsSpecList[p].currOrderCount+1
								){
								return "超过库存";
							}


							// 更新数量 
							if (action == "+") {
								 this.detail.goodsSpecList[p].currOrderCount++;
							} else {
								this.detail.goodsSpecList[p].currOrderCount--;
								if (this.detail.goodsSpecList[p].currOrderCount < 0) {
									this.detail.goodsSpecList[p].currOrderCount = 0; 
								}
							}

						}

						//统计单品
						goodsCount += this.detail.goodsSpecList[p].currOrderCount;
					}

					//统计多规格订购数量
					//var totalSpecCount=goodsList[i].goodsSpecList);
					//goodsObj.currOrderCount=goodsCount;
					this.detail.currOrderCount = goodsCount;

					//设置价格
					//goodsObj = this.setPackagePrice(goodsObj);
					
					//this.detail= goodsObj;
					return this.detail;
				}catch(error){
					console.log("捕获错误",error);
				}
				
			},

			
			callPhone(){
				let phone="18159890625";
				//拨打电话
				window.location.href = `tel:${phone}`;
				// window.$utils.uniapi.makePhoneCall({
				// 	phoneNumber:"13100000000",//替换为实际的电话号码
				// 	success:function(){
				// 		console.log("拨打电话成功！");
				// 	},
				// 	fail:function(err){
				// 		console.log("拨打电话失败：",err);
				// 	}
				// });
			},
			
			/**
			 * 更新list数量
			 * @param {} action 
			 * @param {*} goodsId 
			 * @param {*} specId 
			 */
			changeCountForList(action, goodsId, specId) {
				if (!!specId == false) {
					console.log("缺少规格");
					return;
				}
				var goodsObj = {};
				var goodsList = this.goodsList;
				for (var i = 0; i < goodsList.length; i++) {
					if (goodsList[i].id == goodsId) {

						var goodsCount = 0; //单品订购数量
						for (var p = 0; p < goodsList[i].goodsSpecList.length; p++) {
							if (goodsList[i].goodsSpecList[p].id == specId) {
								if (typeof goodsList[i].goodsSpecList[p].currOrderCount == 'undefined') {
									goodsList[i].goodsSpecList[p].currOrderCount = 0;
								}
								//更新数量
								if (action == "+") {
									goodsList[i].goodsSpecList[p].currOrderCount++;
								} else {
									goodsList[i].goodsSpecList[p].currOrderCount--;
									if (goodsList[i].goodsSpecList[p].currOrderCount < 0) {
										goodsList[i].goodsSpecList[p].currOrderCount = 0;
									}
								}

								//更新选品
								goodsObj = goodsList[i];
							}

							//统计单品
							goodsCount += goodsList[i].goodsSpecList[p].currOrderCount;
						}

						//统计多规格订购数量
						//var totalSpecCount=goodsList[i].goodsSpecList);
						goodsObj.currOrderCount = goodsCount;
						goodsList[i].currOrderCount = goodsCount;



					}
				}
				this.goodsList = goodsList;
				this.selectedGoods = goodsObj;

				return goodsObj;
			},


			addCart(goodsObject) {

				var totalCount = 0;
				var totalAmount = 0;

				var cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];

				var index = -1; //商品在购物车中的序号
				for (var i = 0; i < cartGoodsList.length; i++) {
					if (cartGoodsList[i].id == goodsObject.id) {
						index = i;
						break;
					}
				}
				console.log("更新购物车数据", cartGoodsList);
				if (index > -1) {
					//置换数据
					if (goodsObject.currOrderCount > 0) {
						cartGoodsList[index] = goodsObject;
					} else {
						//移除
						cartGoodsList.splice(i,
							1
						); //arrayObj.splice(deletePos,deleteCount); //删除从指定位置deletePos开始的指定数量deleteCount的元素，数组形式返回所移除的元素
					}
				} else {
					cartGoodsList.push(goodsObject);
				}

				//更新统计
				for (var i = 0; i < cartGoodsList.length; i++) {
					console.log('cartGoodsList[i].goodsSpecList ', cartGoodsList[i].goodsSpecList);
					for (var p = 0; p < cartGoodsList[i].goodsSpecList.length; p++) {
						if (cartGoodsList[i].goodsSpecList[p].currOrderCount <= 0) continue;
						totalCount += cartGoodsList[i].goodsSpecList[p].currOrderCount;
						totalAmount += cartGoodsList[i].goodsSpecList[p].currOrderCount * cartGoodsList[i].goodsSpecList[p]
							.price;
					}
				}

				window.$utils.uniapi.setStorageSync('cartGoodsList', cartGoodsList);


				//提示
				// if (totalCount > 0) {
				// 	window.$utils.uniapi.setTabBarBadge({ index: 2, text: '' + totalCount });
				// } else {
				// 	window.$utils.uniapi.removeTabBarBadge({ index: 2 });
				// }
				// window.$store.state.cartGoodsCount=totalCount;
				window.$store.commit('setCartGoodsCount', totalCount)

				//数据
				this.totalCount = totalCount;
				this.totalAmount = totalAmount.toFixed(2);
			},
			
			
			    // previewImage(url) {
				// 	if(!!url==false)return;
			    //   // 假设你的图片列表只有一个图片，实际应用中应该是一个数组
			    //   const urls = [url]; // 如果需要预览多张图片，这里应该是一个包含所有图片地址的数组
			    //   window.$utils.uniapi.previewImage({
			    //     current: 0, // 当前显示图片的索引，默认是0
			    //     urls: urls // 需要预览的图片http链接列表
			    //   });
			    // }

		}
	}
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.article-meta {
		padding: 10px 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		color: gray;
	}

	.article-text {
		font-size: 13px;
		line-height: 25px;
		margin: 0 10px;
	}

	.article-author,
	.article-time {
		font-size: 15px;
	}

	.article-content {
		padding: 0 15px;
		overflow: hidden;
		font-size: 15px;
		margin-bottom: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/views/goods/detail.vue